// Why one photo failed to upload — said in words the uploader can act on.
//
// The editor used to end a failed photo with « Erreur » and nothing else.
// #1227 (2026-10-03): 35 valid JPEGs all ended « Erreur », and the team told
// the client her photos were unreadable. The storage had refused their NAME
// (« Invalid key », fixed on the worker) — a reason nobody could see.
//
// Guard: src/lib/uploadFailureReason.test.ts

type UploadError = { message?: unknown; status?: unknown; code?: unknown };

/** A short French reason for one failed photo. Never empty, never the raw error. */
export function uploadFailureReason(e: unknown): string {
  const err = (e && typeof e === 'object' ? e : { message: e }) as UploadError;
  const msg = String(err.message ?? e ?? '');
  const status = Number(err.status);
  if (/invalid key/i.test(msg)) return 'nom du fichier refusé par le stockage — réessayez (le nom est corrigé à l’envoi)';
  if (/mime type|invalid_mime|not supported/i.test(msg)) return 'format refusé — formats acceptés : JPG, PNG, WebP, HEIC';
  if (status === 413 || /too large|maximum allowed size|payload too large|exceeded/i.test(msg)) return 'fichier trop lourd (50 Mo maximum)';
  if (err.code === 'STALL' || err.code === 'NETWORK' || /stalled|network|aborted|timeout|timed out/i.test(msg)) {
    return 'connexion interrompue — réessayez';
  }
  if (/decode|createImageBitmap|image load|EncodingError|not an image|unsupported image/i.test(msg)) {
    return 'image illisible par ce navigateur — essayez depuis un autre appareil';
  }
  return 'échec de l’envoi — réessayez';
}
